import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sprintTab',
  pure: false
})

export class SprintTabPipe implements PipeTransform {
  transform(items: any[], filter: any, type: any): any {
    if (type.type == 'count') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (item.assignedto === filter.assignedto) {
          count++;
        }
      }
      return count;
    }else if (type.type == 'project') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (item.assignedto === '') {
          count++;
        }
        // if(item.assignedto != '' && item.activity.type == 'RI'){
        //   count++;
        // }
      }
      return count;
    } else if (type.type == 'list') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (item.history === filter.history) {
          return item;
        }
      }
    }
  }
}

